export enum TypeBoCodeEnum {
  BO1 = 'BO1',
  BO3 = 'BO3',
  BO5 = 'BO5',
}
